export default __webpack_public_path__ + "78eaefa91d48cd67588311de2ca77d70.svg";